import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from '@emotion/styled';
var GraphPaper = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-image: ", ";\n  background-size: 100px 100px, 100px 100px, 20px 20px, 20px 20px;\n  background-position: -2px -2px, -2px -2px, -1px -1px, -1px -1px;\n  width: 100%;\n  height: 100%;\n"])), function (_ref) {
  var gridColor = _ref.gridColor;
  return "linear-gradient(".concat(gridColor, ", 2px, transparent 2px), linear-gradient(90deg, ").concat(gridColor, ",  2px, transparent 2px), linear-gradient(rgba(150, 150, 150, .3) 1px, transparent 1px), linear-gradient(90deg, rgba(150, 150, 150, .3) 1px, transparent 1px)");
});
export default GraphPaper;